import { render, staticRenderFns } from "./TemplatePanel.vue?vue&type=template&id=f1f5d50a&scoped=true"
import script from "./TemplatePanel.vue?vue&type=script&lang=js"
export * from "./TemplatePanel.vue?vue&type=script&lang=js"
import style0 from "./TemplatePanel.vue?vue&type=style&index=0&id=f1f5d50a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f5d50a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1f5d50a')) {
      api.createRecord('f1f5d50a', component.options)
    } else {
      api.reload('f1f5d50a', component.options)
    }
    module.hot.accept("./TemplatePanel.vue?vue&type=template&id=f1f5d50a&scoped=true", function () {
      api.rerender('f1f5d50a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/editor/settingPanel/TemplatePanel.vue"
export default component.exports